import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Button, Checkbox, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useUpdateTrainingStatus } from 'modules/trainings/hooks/Trainings/useUpdateTrainingStatus'

interface Props {
  status: string
}
export const StartTrainingModal = ({ status }: Props) => {
  const { id } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [notify, setNotify] = React.useState<boolean>(true)
  const navigateBack = () => {
    navigate(navigation.trainings.list.details_revamp.view.overview.fullPath({ id: String(id) }))
  }
  const { updateTrainingStatus } = useUpdateTrainingStatus()
  const isStartModal = status === 'active'
  const title = isStartModal
    ? i18n.t('trainings.trainings_detail.start_training_modal.title')
    : i18n.t('trainings.trainings_detail.stop_training_modal.title')
  const description = isStartModal
    ? i18n.t('trainings.trainings_detail.start_training_modal.description')
    : i18n.t('trainings.trainings_detail.stop_training_modal.description')
  const emailNotificationDescription = isStartModal
    ? i18n.t('trainings.trainings_detail.start_training_modal.email_notification')
    : i18n.t('trainings.trainings_detail.stop_training_modal.email_notification')
  const errorMessage = isStartModal
    ? i18n.t('trainings.trainings_detail.start_training_modal.start_error')
    : i18n.t('trainings.trainings_detail.stop_training_modal.stop_error')
  const successMessage = i18n.t('trainings.trainings_detail.start_training_modal.start_success')
  const onSubmit = async () => {
    const response = await updateTrainingStatus({ id: String(id), status: status, notify: notify })
    const handled = handleResult(response, ({}) => {
      app.setFlash({
        type: 'wrong',
        message: errorMessage,
      })

      return
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: successMessage,
      })

      navigateBack()
    }
  }
  return (
    <Modal
      title={title}
      description={description}
      onClose={navigateBack}
      footer={
        <Box flexDirection="row" gap="s8">
          <Button type="secondary" onClick={navigateBack}>
            {i18n.t('trainings.trainings_detail.start_training_modal.cancel_button')}
          </Button>
          <Button submit>
            {isStartModal
              ? i18n.t('trainings.trainings_detail.start_training_modal.start_button')
              : i18n.t('trainings.trainings_detail.stop_training_modal.stop_button')}
          </Button>
        </Box>
      }
      onSubmit={() => onSubmit()}
    >
      <Box flexDirection="row" gap="s12" alignItems="flexStart">
        <Checkbox onChange={() => setNotify(!notify)} checked={notify} size="large" />
        <Text.Normal weight="semibold">{emailNotificationDescription}</Text.Normal>
      </Box>
    </Modal>
  )
}
